(function (scope) {
  const solar = [67596232884392, 67596233113768];
  const idOf = item => Number(item.variant_id || item.id);
  function plan(config, items, preferred) {
    const present = new Set(items.map(idOf));
    const families = Object.keys(config.main).filter(key => present.has(config.main[key]));
    const page = Object.keys(config.main).find(key => config.main[key] === config.currentVariant);
    const active = families.includes(page) ? page : families.includes(preferred) ? preferred : families[0];
    if (!active) return null;
    // Never hide an existing paid item just because it has since sold out.
    const products = config.products.filter(p => p.id && (p.available || present.has(p.id)));
    const byId = new Map(products.map(p => [p.id, p]));
    const equivalent = id => solar.includes(id) ? solar.find(other => present.has(other)) || id : id;
    const make = (id, useEquivalent = true) => {
      const actualId = useEquivalent ? equivalent(id) : id, product = byId.get(actualId) || byId.get(id);
      if (!product) return null;
      const lines = items.filter(item => idOf(item) === actualId);
      const quantity = lines.reduce((total, item) => total + Number(item.quantity || 1), 0);
      return { ...product, id: actualId, selected: lines.length > 0, quantity,
        cents: lines.length ? lines.reduce((total, item) => total + (Number.isFinite(item.final_line_price) ? item.final_line_price : product.cents * Number(item.quantity || 1)), 0) : product.cents };
    };
    const lifetime = make(config.lifetime[active]);
    const core = config.core[active].filter(id => id !== config.lifetime[active]).map(id => make(id)).filter(Boolean);
    const represented = new Set([...core.map(p => p.id), lifetime?.id]);
    // Extras are batch-added by default, so they render with their real
    // selected state instead of only appearing once removed.
    const extra = config.extra[active].map(id => make(id)).filter(p => p && !represented.has(p.id));
    extra.forEach(p => represented.add(p.id));
    const other = [...present].filter(id => byId.has(id) && !represented.has(id)).map(id => make(id, false)).filter(Boolean);
    return {active, core, lifetime, other, extra};
  }
  function removalUpdates(items, id) {
    return Object.fromEntries(items.filter(item => idOf(item) === Number(id)).map(item => [item.key, 0]));
  }
  const api = { plan, removalUpdates, idOf };
  scope.DMCartPlan = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window === 'undefined' ? globalThis : window);
